import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import '../css/Form.css'; // Import your CSS for styling

const OtpVerification = () => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state; // Get the email from the previous page

  const [resendOtpEnabled, setResendOtpEnabled] = useState(false); // Flag for resend button
  const [resendTimer, setResendTimer] = useState(60); // Timer in seconds (1 minute)

  console.log('Received email:', email);

  const handleChange = (e) => {
    setOtp(e.target.value);
  };

  const handleResendOtp = async () => {
    try {
      // Make an axios POST request to http://localhost:8081/api/auth/resendOtp
      const url = new URL(`${process.env.REACT_APP_API_URL}/api/auth/resendOtp`);
      url.searchParams.append('email', email);

      // Make an axios POST request with the constructed URL
      const response = await axios.post(url.toString());

      if (response.status === 200) { // Assuming 200 OK for successful resend
        setResendOtpEnabled(false); // Disable button and restart timer
        setResendTimer(60);
        setSuccessMessage('OTP resent successfully!');
      } else {
        setError('Failed to resend OTP. Please try again later.');
      }
    } catch (error) {
      console.error('OTP resend error:', error);
      setError('Failed to resend OTP. Please try again later.');
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      if (resendTimer > 0) {
        setResendTimer(resendTimer - 1);
      } else {
        setResendOtpEnabled(true); // Enable button after timer expires
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer); // Cleanup on component unmount
  }, [resendTimer]); // Dependency array: update timer only when resendTimer changes

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    try {
      // Construct the URL with query parameters (preferred for OTP verification)
      const url = new URL(`${process.env.REACT_APP_API_URL}/api/auth/verify`);
      url.searchParams.append('email', email);
      url.searchParams.append('otp', otp);

      // Make an axios POST request with the constructed URL
      const response = await axios.post(url.toString());

      if (response.status === 200) { // Assuming 200 OK for successful verification
        setSuccessMessage('OTP verified successfully! Redirecting to login...');
        setTimeout(() => {
          navigate('/login'); // Redirect to login page after a delay
        }, 2000);
      } else {
        setError('Invalid OTP. Please try again.');
      }
    } catch (error) {
      console.error('OTP verification error:', error);
      setError('Invalid OTP. Please try again.');
    }
  };

  return (
    <div className="form-container">
      <div className="form-wrapper">
        <h2>Enter OTP</h2>
        <p className="otp-instruction">
          Please enter the OTP sent to <strong>{email}</strong>
        </p>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              name="otp"
              placeholder="Enter OTP"
              onChange={handleChange}
              value={otp}
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          {successMessage && <div className="success-message">{successMessage}</div>}
          <button type="submit" className="submit-btn">Verify OTP</button>
          <br />
          <button
            type="button"
            className={`resend-otp-btn ${resendOtpEnabled ? '' : 'disabled'}`}
            disabled={!resendOtpEnabled}
            onClick={handleResendOtp}
          >
            Resend OTP ({resendTimer}s)
          </button>
        </form>
      </div>
    </div>
  );
};

export default OtpVerification;